import * as React from 'react';

import UserApi from '../modules/users/api/UserApi';
import {Form, Header, Button, Input, Breadcrumb} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import {RouteComponentProps} from 'react-router';
import Page from './Page';
import * as Validator from 'validator';
import Registry from '../global/Registry';

interface State {
	emailAddress: string;
	completed: boolean;
}

export default class ResetPasswordPage extends Page<RouteComponentProps<void>, State> {

	public constructor (props: RouteComponentProps<void>) {
		super(props);

		this.state = {
			emailAddress: '',
			completed: false
		};
	}

	protected isLoading () {
		return false;
	}

	protected renderTitle () {
		return 'Reset your password - Brain Brooder';
	}

	protected renderDescription () {
		return 'Reset your password for Brain Brooder.';
	}

	protected renderContent () {
		const sections = [{ key: 'Home', content: <Link to={'/'}>Home</Link> }, { key: 'Reset your password', content: 'Reset your password', active: true }];

		return (
			<div className={'lesson'}>
				<Breadcrumb icon='right angle' sections={sections} />

				<Header dividing as='h1' inverted>Reset your password</Header>

				<Form inverted onSubmit={this.resetPassword} style={{textAlign: 'center'}}>

					{this.state.completed ? (
						<p style={{fontSize: '1.3em', marginTop: '32px'}}>We've sent an email to <strong>{this.state.emailAddress}</strong> with a link that let's you choose a new password.</p>
					) : (
						<div>
							<Form.Field>
								<label>Email address</label>
								<Input autoFocus={true} transparent type='text' placeholder='Email address' value={this.state.emailAddress} onChange={(event: any) => this.setState({emailAddress: event.target.value})}/>
							</Form.Field>

							<div style={{display: 'block', margin: '-12px 0 24px 0px', fontSize: '0.9em'}}>
								<Link to='/sign-in'>Wait! Now I remember again.</Link>
							</div>

							<Button inverted type='submit'>Send password reset email</Button>
						</div>
					)}
				</Form>
			</div>
		);

		return (
			<Form inverted onSubmit={this.resetPassword} style={{maxWidth: '640px', margin: 'auto'}}>
				<Header inverted as='h1' className='pageHeader'>Reset your password</Header>

				{this.renderFormContent()}
			</Form>
		);
	}

	private resetPassword = async (event: Event) => {
		event.preventDefault();

		if (!Validator.isEmail(this.state.emailAddress)) {
			await Registry.getInstance().addErrorMessage('You haven\'t entered a valid email address.');
			return;
		}

		event.preventDefault();

		await UserApi.getInstance().resetPassword(this.state.emailAddress);

		this.setState({completed: true});
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/ResetPasswordPage.tsx